require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./es-fleet-standard-elite-suv.json") })
        }
      }, "path---es-fleet-standard-elite-suv");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---es-fleet-standard-elite-suv!./.cache/json/es-fleet-standard-elite-suv.json
// module id = 1090
// module chunks = 231608221292675